import {openAdminDashboard} from '../platform/auth';
// Four destinations keep related settings together.
import React from 'react';
import { Platform } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useNav } from '../navigation';
import { ListItem, Screen, Section } from '../components/ui';
import { useAccount } from '../store/account';

export default function SettingsScreen() {
  const { t } = useTranslation();
  const nav = useNav();
  const isAdmin = useAccount(s => s.user?.isAdmin === true);
  return (
    <Screen>
      <Section>
        <ListItem title={t('settings.help')} icon="help" onPress={() => nav.navigate('Info', { page: 'help' })} />
        <ListItem title={t('settings.account')} icon="lock" onPress={() => nav.navigate('Account')} />
        {Platform.OS === 'web' && isAdmin ? <ListItem title={t('settings.adminDashboard')} icon="lock" onPress={openAdminDashboard} /> : null}
        <ListItem title={t('settings.personal')} icon="user" onPress={() => nav.navigate('PersonalSettings')} />
        <ListItem title={t('settings.app')} icon="settings" onPress={() => nav.navigate('AppSettings')} />
      </Section>
    </Screen>
  );
}
